export default __webpack_public_path__ + "static/media/mod-oku.03aaa8b3.png";